import template from './shiptype.edit.html';
import controller from './shiptype.edit.controller';
import './shiptype.edit.scss';

let shiptypeeditComponent = {
  restrict: 'E',
  bindings: {
    hasACL:'='
  },
  template,
  controller
};

export default shiptypeeditComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/shiptype/edit/shiptype.edit.component.js